export default "__VITE_ASSET__u78j$FdI__"